<div
	*ngIf="isLegalPage"
	class="legal-app-navigation"
>
	<app-header
		[publicView]="true"
		[returnUrl]="legalReturnUrl"
	></app-header>
</div>
<router-outlet></router-outlet>
<app-footer *ngIf="isLegalPage"></app-footer>
